<template>
  <transition name="tips" @after-leave="handleAfterLeave">
    <div class="tip-body" :class="isClass" v-if="visible">
      <div class="tip-box">
        <i v-if="icon" :class="'u-icon-' + icon"></i>
        <div class="tip-txt" v-html="content"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'UToast',
  data() {
    return {
      content: '',
      time: 2000,
      visible: false,
      isClass: '',
      isClose: true,
      callback: null,
      icon: '',
    };
  },
  watch: {
    isClose(newVal, oldVal) {
      if (newVal) {
        this.close();
      }
    },
  },
  mounted() {
    if (this.isClose) {
      this.close();
    }
  },
  methods: {
    handleAfterLeave() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    close() {
      window.setTimeout(() => {
        this.visible = false;
      }, this.time);
    },
  },
};
</script>
<style lang="scss" scoped>
.tip-body {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3000;
  .tip-box {
    line-height: 0.42rem;
    padding: 0.4rem 0.5rem;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 0.4rem;
    color: #fff;
    font-size: 0.3rem;
    box-sizing: border-box;
    min-width: 2.8rem;
    max-width: 3.8rem;
    min-height: 2rem;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%); /* IE 9 */
    -webkit-transform: translate(-50%, -50%); /* Safari and Chrome */
    -o-transform: translate(-50%, -50%); /* Opera */
    -moz-transform: translate(-50%, -50%); /* Firefox */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
[class^='u-icon-'],
[class*=' u-icon-'] {
  font-size: 1rem;
  margin-bottom: 0.2rem;
}
.u-icon-load {
  animation: rotateAni 3s linear infinite;
}
</style>
